<template>

    <div class="mb-3" :class="{'form-floating': floating}">

        <label v-if="label && floating === false" class="form-label" :for="id">
            {{ translatedLabel }}
            <span v-if="help">
                <i class="bi bi-question-circle" :title="help"></i>
            </span>
        </label>

        <div class="input-group">
            <input 
                :id="id" 
                ref="input"
                v-bind="$attrs"
                type="number"
                class="form-control" 
                :min="min"
                :max="max"
                :step="step"
                :class="{ 'is-invalid': error }" 
                :placeholder="floating && !placeholder ? translatedLabel : placeholder" 
                :value="value" 
                @input="$emit('input', $event.target.value)" />
            <span class="input-group-text">%</span>
            <div v-if="error" class="invalid-feedback">{{ error }}</div>
        </div>

        <label v-if="label && floating" class="form-label" :for="id">
            {{ translatedLabel }}
        </label>

    </div>

</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            id: {
                type: String,
                default() {
                    return `percent-input-${this._uid}`
                },
            },
            value: {
                default: '',
            },
            step: {
                default: .01,
            },
            min: {
                default: 0,
            },
            max: {
            },
            placeholder: {
                default: '',
            },
            floating: {
                default: false,
            },
            label: String,
            error: String,
            help: String,

        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
        methods: {
            focus() {
                this.$refs.input.focus()
            },
            select() {
                this.$refs.input.select()
            },
            setSelectionRange(start, end) {
                this.$refs.input.setSelectionRange(start, end)
            },
        },
    }
</script>